module.exports = "/_next/static/files/bc2cc22cfd5cd2ea9b91f35bd70742f4.png";